import {
  Container,
  Typography,
  Stack,
  IconButton,
  TextField,
  Button,
} from "@mui/material";
import { t } from "i18next";
import { Box } from "@mui/system";
import SearchIcon from "@mui/icons-material/Search";
import AccardionGuid from "../../components/atomic/accardion-guid";
import "./Guid.css";
import { useEffect } from "react";

const Guid = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "   راهنما";
  }, []);
  return (
    <>
      <Box
        sx={{
          bgcolor: "background.default",
          textAlign: "center",
          py: 6,
          position: "relative",
        }}
      >
        <Stack
          direction={"row"}
          mb={2}
          spacing={4}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <div
            style={{
              background:
                "linear-gradient(90deg, #8E2DE2 0.33%, rgba(74, 0, 224, 0.51) 100.65%)",
              width: "130px",
              height: "1px",
            }}
          ></div>
          <Typography
            variant="h4"
            sx={{ textAlign: "center", color: "text.primary" }}
          >
            {t("rabsana_guid")}
          </Typography>
          <div
            style={{
              background:
                "linear-gradient(90deg, #8E2DE2 0.33%, rgba(74, 0, 224, 0.51) 100.65%)",
              transform: "rotate(-180deg)",
              width: "130px",
              height: "1px",
            }}
          ></div>
        </Stack>
        <Box sx={{ mt: 4 }}>
          <TextField
            className="search-input-faq"
            sx={{
              width: { md: "35%", xs: "90%" },
              color: "#fff",
              bgcolor: "background.darkBlack",
            }}
            placeholder={`${t("ask_your_question")}`}
            InputProps={{
              style: {
                padding: ".1rem 1.5rem",
                borderRadius: "50px",
                border: "none",
                color: "#fff",
              },
              endAdornment: (
                <IconButton sx={{}}>
                  <SearchIcon fontSize="large" />
                </IconButton>
              ),
            }}
          />
        </Box>
      </Box>
      <Box sx={{ pb: 8, pt: 2, bgcolor: "background.default" }}>
        <Container>
          <AccardionGuid />
          <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent={"space-between"}
            alignItems={{ xs: "start", sm: "center" }}
            sx={{
              bgcolor: "background.darkBlack",
              px: 4,
              py: 4,
              borderRadius: "10px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "start",
                flexDirection: "column",
              }}
            >
              <Typography
                variant="h6"
                component="h3"
                color="text.title"
                sx={{ textAlign: "start" }}
              >
                {t("not_found_answer")}
              </Typography>
              <Typography
                variant="h6"
                component="h4"
                color="text.title"
                sx={{ textAlign: "start", fontWeight: 300, mt: 1 }}
              >
                {t("not_found_answer_paragraph")}
              </Typography>
            </Box>
            <Button
              variant="contained"
              sx={{
                width: "10rem",
                height: "2.5rem",
                px: 2,
                py: 2.5,
                borderRadius: "50px",
                background: "#FF3DFF",
                mt: { xs: 2, sm: 0 },
              }}
            >
              {t("ask_your_question")}
            </Button>
          </Stack>
        </Container>
      </Box>
    </>
  );
};

export default Guid;
